import SocketIO from 'socket.io-client'
import {
 SOCKET_CREATED,
 SOCKET_CONNECTED,
 SOCKET_DISCONNECTED,
 BLOCKS_MINED_ADD,
 RETRIEVING_DATA,
 WALLET_SET,
 NO_RPC
} from '../actions/types';

import {getBalances} from '../actions/passport/get';
import {getSpendableOutpoints} from '../actions/passport/get/nrg';
import {getOpenOrders, getMatchedOrders} from '../actions/orderbook/get';
import {collateralizeFilter} from '../actions/orderbook/filter';
import {getAllTransfers} from '../actions/transfers/get';
import {checkPending} from '../actions/transfers/set/addPending';
import callBC from '../actions/helpers/bc';

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

export const initSocket = (location, dispatch, store) => {
  // console.log({location})

  //backwords compatability
  let wallet = window.getStorage('bc-wallet')
  if(wallet && wallet.emb && wallet.emb.address){
    let newWallet = {};
    Object.keys(wallet).map((asset)=>{
      newWallet[asset] = {}
      newWallet[asset][wallet[asset].address] = {
        privateKey: wallet[asset].privateKey,
        salt: wallet[asset].salt,
        iv: wallet[asset].iv,
      }
    })
    dispatch({type:WALLET_SET,payload:newWallet})
  }

  //KEY-VALUE FIX
  for(let key of Object.keys(window.localStorage).filter((str)=>{return str.length === 70 || str.length === 71})){
    window.localStorage.removeItem(key)
  }
  for(let key of Object.keys(window.localStorage).filter((str)=>{return str.includes('unlocking')})){
    window.localStorage.removeItem(key)
  }

  let hostname = location.hostname.replace(/https?:\/\//, '')
  hostname = hostname.replace(/http?:\/\//, '')

  // console.log({hostname})

  let url = location.port !=='' ? `ws://${hostname}:${location.port}` : `wss://${hostname}`;
  if(location.hostname.includes('ngrok') || location.hostname.includes('https')) url = `wss://${hostname}`;

  let startSocket = () => {
    console.log('started')
    console.log({location})
    callBC(location,'getSyncStatus',[]).then((data)=>{
      console.log({data})
      if(data && data.result && data.result.status === 'complete') {
        const socket = SocketIO(url, {path: '/ws',rejectUnauthorized: false,transports:['websocket']});

        dispatch({type:SOCKET_CREATED,payload:{socket,location}})

        socket.on('connect', () => {
          dispatch({type: SOCKET_CONNECTED,payload:socket})
          socket.on('disconnect', ()=> dispatch({type: SOCKET_DISCONNECTED}))

          //get latest block when we start up
          socket.emit('block.get',{id:'latest'});

          const events = ['block.set','block.mined','block.new','block.latest']
          events.forEach((event) => {
            socket.on(event, async (data) => {
              if(data) updateOrdersState(data,dispatch,store)
            })
          })
        });
      }
    });
  }

  startSocket()
  setInterval(()=>{
    console.log(store.getState().socket.connected)
    if(!store.getState().socket.connected){
      if(store.getState().socket.socket && store.getState().socket.socket.connected){
        store.getState().socket.socket.disconnect()
      }
      startSocket()
    }
  },1000)

}

//on each new block, get balances and orders
const updateOrdersState = async (data,dispatch,store) => {
  if(data)dispatch({type:BLOCKS_MINED_ADD,payload:data});
  if(store.getState().socket.retrieving === false || store.getState().ui_passport.loading === true && !store.getState().socket.no_rpc){
    dispatch({type:RETRIEVING_DATA,payload:true})
    await Promise.all([
      getMatchedOrders(false,dispatch,store.getState()),
      getOrders(dispatch,store),
      checkPending(dispatch,store.getState()),
      getBalances(dispatch,store.getState()),
      // getSpendableOutpoints(dispatch,store.getState()),
      getAllTransfers(dispatch,store.getState)
    ])
    dispatch({type:RETRIEVING_DATA,payload:false})
  }
}

let getOrders = async (dispatch,store) => {
  await getOpenOrders(dispatch,store.getState())
  collateralizeFilter(dispatch,store.getState())
}
